"use client"
import React, { useContext, useEffect, useState } from 'react'
import { Formik, Form } from 'formik';
import { ConnectedFocusError } from 'focus-formik-error';
import _ from 'lodash';
import withStepperHOC from '@/HOC/withStepperHOC';
import CheckoutSection from '@/components/checkoutSteps/CheckoutSection';
import { signUpValidationSchema } from '@/services/Methods/validationSchema';
import { CreateObject } from '@/services/Methods/checkoutPayloads';
import withRouteHOC from '@/HOC/withRouterHOC';
import withFormHOC from '@/HOC/withFormHOC';
import { ContextData, storeAssigned } from '@/services/Methods/normalMethods';
import StepperComponentInputs from '@/Inputs/StepperComponent.inputs';
import Viagoicon from '../../../assets/icons/viagoicon.png';
import Image from 'next/image';
import Ambassador from '@/components/mainEnrollment/Ambassador';
import ClubViagoLaunchPack from '@/components/mainEnrollment/ClubViagoLaunchPack';
import DialogComponent from '@/Inputs/DailogComponent';
import ButtonComponent from '@/Inputs/ButtonComponent';
import localStorageCall from '@/services/Methods/localstorage.hook';
import { useRouter } from 'next/navigation';
import Loader from '@/comman/Loader';

const section = 'normal';
const rankUpgrad = 'main_enrollment';
const isWebAlias = true;

const MainEnrollmentSignup = (props) => {
    const otherData = useContext(ContextData);
    const router = useRouter();
    const [displayPopup, setDisplayPopup] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [setpActive, setStepActive] = useState(0)

    const {
        // make sure you have to pass section && products
        countryCodes, pathname,
        otp, FormId, activeStep, setActiveStep, formData, emailExistError, setOpenMiniCart, userData,
        countryState, setCountryState, addToCartProducts, setAddToCartProduct, webAliesError, setWebAliesErros,
        handleChangeValidate, _handleSubmit, _handleOtpSubmit, isUserLogin, _validateRefferalFunction, searchParams,
        UserCountry, storeAssignUppercase, userIpCountry, Localkey, setShowPopup, showPopup, storeAssign, setStoreAssign, setSelectedStore

    } = { ...props, ...otherData }
    const cartProducts = addToCartProducts['normalProducts'] || [];

    // console.log("sectionsectionsectionsectionsection", section);


    const AutoshipTrue = _.find(addToCartProducts?.[`${section}Products`], { frequency: 'autoship' })
    const AUTOSHIP_PRODUCTS_ON_CART = _.map(_.filter(addToCartProducts?.[`${section}Products`], { frequency: 'autoship' }), (r) => CreateObject(r, AutoshipTrue));

    const ViagoLaunchPack = _.find(cartProducts, { title: "Club Viágo Launch Pack" });
    const PRODUCTS_ON_CART = _.map(addToCartProducts?.normalProducts, (r) => CreateObject(r));

    useEffect(() => {
        const setTImeOut = setTimeout(() => {
            if (cartProducts?.length === 0 && activeStep === 2) {
                window.location.assign(`/${storeAssigned()}/main-enrollment`);
            }
        }, [2000]);

        return () => clearTimeout(setTImeOut)

    }, [cartProducts, activeStep]);


    const getStepContent = (step, fieldValue) => {
        switch (step) {
            case 0: return <ClubViagoLaunchPack {...{
                cartProducts, addToCartProducts, setAddToCartProduct, setOpenMiniCart, activeStep, setActiveStep, section: section, rankUpgrad: rankUpgrad, setStepActive, setpActive, userData, isUserLogin, pathname,
                UserCountry, storeAssignUppercase, userIpCountry, Localkey, setShowPopup, showPopup, storeAssign, setStoreAssign, setSelectedStore,

            }} />;
            case 1: return <Ambassador {...{
                cartProducts, addToCartProducts, setAddToCartProduct, setOpenMiniCart, activeStep, setActiveStep, section: section, rankUpgrad: rankUpgrad, setStepActive
            }} />
            case 2: return cartProducts?.length > 0 ?
                <CheckoutSection {...{
                    addToCartProducts, setAddToCartProduct, countryCodes, setOpenMiniCart, activeStep, setActiveStep, rankUpgrad: rankUpgrad, AUTOSHIP_PRODUCTS_ON_CART, PRODUCTS_ON_CART, webAliesError, setWebAliesErros,
                    ...props
                }} /> : "Add the products";

            default: return 'Unknown step';
        }
    };

    const steps = ['Club Viago Launch Pack', 'Become an Ambassador', 'Checkout'];
    // console.log("activeStep", activeStep);


    const handleClickBack = () => {
        if (ViagoLaunchPack && activeStep === 1) {
            setDisplayPopup(true);
        } else {
            setActiveStep(activeStep - 1);
        }
        localStorageCall().removeItem('activeStep');
    }

    useEffect(() => {
        const ROLE = localStorageCall().getItem('customerTypeDescr')?.role || 'normal';

        if ((ROLE === 'member' || ROLE === 'ambassador') && isUserLogin) {
            router.push(`/${storeAssigned()}`)
        } else {
            setTimeout(() => setLoading(false), 1000);
        }
        setAddToCartProduct({ normalProducts: [] });
    }, [])

    return (
        isLoading ? (
            <Loader />
        ) : (
            <>
                <div className="px-[15px] xl:max-w-[1140px] lg:max-w-[990px] mx-auto xl:pb-[150px] pb-[50px]">
                    <div className='justify-center flex lg:pt-50px pt-30px'>
                        <Image src={Viagoicon} alt="" className="w-full h-full object-cover block max-w-64" />
                    </div>
                    <StepperComponentInputs steps={steps} activeStep={activeStep}>
                        {activeStep >= 1 &&
                            //    <button onClick={()=>setActiveStep(activeStep-1)}>Back</button>
                            <button
                                onClick={handleClickBack}
                                className="flex items-center px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5 mr-2"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                                </svg>
                                {activeStep === 1 && ViagoLaunchPack ? 'Start Over' : 'Back'}
                            </button>
                        }

                        {activeStep === 1 && <h3 className='text-center py-3'>{steps[activeStep]}</h3>}
                        <div className="form_section">
                            {(activeStep === 1)
                                ?
                                <Formik
                                    id={FormId}
                                    enableReinitialize
                                    initialValues={formData}
                                    validationSchema={signUpValidationSchema(1, isUserLogin, isWebAlias)}
                                    onSubmit={(values, actions) => _handleSubmit(values, actions)}
                                >
                                    {(fieldValue) => (
                                        <Form>
                                            <ConnectedFocusError />
                                            {getStepContent(activeStep, fieldValue)}
                                        </Form>
                                    )}
                                </Formik>
                                :
                                getStepContent(activeStep)
                            }

                        </div>
                    </StepperComponentInputs>
                </div>
                <DialogComponent opend={displayPopup} classFor="addessForm">
                    <div className='main-content-section'>
                        <div>
                            <p>You already have Club Viágo Launch Pack in the cart.Your cart will be empty. Do you want to go back?</p>
                        </div>
                        <div className='w-full flex justify-center gap-x-[20px] mt-4'>
                            <ButtonComponent classes="!mb-0 max-w-[200px]" onClick={() => { setDisplayPopup(false) }}>Cancel</ButtonComponent>
                            <ButtonComponent classes="!mb-0 max-w-[200px]" onClick={() => {
                                localStorageCall().removeItem(`normalProducts`);
                                localStorageCall().removeItem('activeStep');
                                setDisplayPopup(false);
                                window.location.assign(`/${storeAssigned()}/main-enrollment`);
                                // setActiveStep(activeStep - 1);
                            }}>Yes</ButtonComponent>
                        </div>
                    </div>

                </DialogComponent>
            </>
        ));
};

MainEnrollmentSignup.defaultProps = {
    section: "normal",
    isWebAlias: false,
    cartProducts: []
}

export default withRouteHOC(withStepperHOC(withFormHOC(MainEnrollmentSignup)));